export const PHLEBO_PG_INCENTIVE_SLABS = [
  {
    category: "Entry",
    revenueMin: 1001,
    revenueMax: 5000,
    incentivePercent: 2.50
  },
  {
    category: "Base",
    revenueMin: 5001,
    revenueMax: 15000,
    incentivePercent: 4.50
  },
  {
    category: "Standard",
    revenueMin: 15001,
    revenueMax: 30000,
    incentivePercent: 9.50
  },
  {
    category: "Bronze",
    revenueMin: 30001,
    revenueMax: 45000,
    incentivePercent: 13.50
  },
  {
    category: "Silver",
    revenueMin: 45001,
    revenueMax: 60000,
    incentivePercent: 16.00
  },
  {
    category: "Gold",
    revenueMin: 60001,
    revenueMax: 90000,
    incentivePercent: 18.50
  },
  {
    category: "Diamond",
    revenueMin: 90001,
    revenueMax: 120000,
    incentivePercent: 22.00
  },
  {
    category: "Platinum",
    revenueMin: 120001,
    revenueMax: null,
    incentivePercent: 25.00
  }
];

export const PHLEBO_WALLET_INCENTIVE_SLABS = [
  {
    category: "Tier 1",
    revenueMin: 0,
    revenueMax: 1000,
    incentivePercent: 0.0
  },
  {
    category: "Tier 2",
    revenueMin: 1001,
    revenueMax: 5000,
    incentivePercent: 3.0
  },
  {
    category: "Tier 3",
    revenueMin: 5001,
    revenueMax: 10000,
    incentivePercent: 4.5
  },
  {
    category: "Tier 4",
    revenueMin: 10001,
    revenueMax: 20000,
    incentivePercent: 6.0
  },
  {
    category: "Tier 5",
    revenueMin: 20001,
    revenueMax: 35000,
    incentivePercent: 7.5
  },
  {
    category: "Tier 6",
    revenueMin: 35001,
    revenueMax: 50000,
    incentivePercent: 9.5
  },
  {
    category: "Tier 7",
    revenueMin: 50001,
    revenueMax: 65000,
    incentivePercent: 11.0
  },
  {
    category: "Tier 8",
    revenueMin: 65001,
    revenueMax: 90000,
    incentivePercent: 12.0
  },
  {
    category: "Tier 9",
    revenueMin: 90001,
    revenueMax: 110000,
    incentivePercent: 13.0
  },
  {
    category: "Tier 10",
    revenueMin: 110001,
    revenueMax: 150000,
    incentivePercent: 13.5
  },
  {
    category: "Tier 11",
    revenueMin: 150001,
    revenueMax: null,
    incentivePercent: 15.0
  }
];
